import { Injectable } from '@angular/core';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PortalBridgeService {
  private activePortals: TemplatePortal[] = [];
  private activePortalsSubject = new Subject<TemplatePortal[]>();
  readonly portals$ = this.activePortalsSubject.asObservable();

  setPortal(portal: TemplatePortal): void {
    this.activePortals.push(portal);
    this.activePortalsSubject.next(this.activePortals);
  }

  removePortal(portalContent: CdkPortal): void {
    this.activePortals = this.activePortals.filter(portal => portal !== portalContent);
    this.activePortalsSubject.next(this.activePortals);
  }
}
